import React, {useState} from "react";
import '../SbtierCSS/SbtierQuery.css';
import axios from "axios";

function SubmitQuery(){
    // Form state
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        queryMessage: ''
    });

    const [status, setStatus] = useState(null);

    // Handling input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handling form submission
    const handleSubmit = async(e) => {
        e.preventDefault();
        try{
            const response = await axios.post('https://sbts-backend-production.up.railway.app/sbtsemiconductor/saveQuery', formData);
            setStatus({
                type: 'success',
                message: response.data?.responseMessage || 'Thank you for reaching out. Our team will contact you soon.'
            });
            setFormData({
                name: '',
                email: '',
                phoneNumber: '',
                queryMessage: ''
            });
        }catch(error){
            console.error('Error:', error);
            setStatus({
                type: 'error',
                message: 'There was an error submitting your form. Please try again.'
            });
        }
    };
    return (
        <section className="contact-us">
            <div className="contact-wrapper">
                <div className="contact-container">
                    {/* Left Side: Contact Information */}
                    <div className="contact-info">
                        <div className="contact-info-item">
                            <img src="images/email.svg" alt="Email Icon" className="contact-icon" />
                            <p>info@sbtsemiconductor.com</p>
                        </div>
                        <div className="contact-info-item">
                            <img src="images/phone.svg" alt="Phone Icon" className="contact-icon" />
                            <p>+91 9871999238 / +91 9910026999</p>
                        </div>
                        <div className="contact-info-item">
                            <img src="images/location.png" alt="Address Icon" className="contact-icon" />
                            <p>
                                Head Office: <br />TH-196, Pallavpuram Phase 2, <br />
                                Modipuram, Meerut Uttar Pradesh-250110.
                            </p>
                        </div>
                    </div>
    
                    {/* Right Side: Contact Form */}
                    <div className="contact-form-container">
                        <h2>Contact Us</h2>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Your Name*</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Your Email*</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phoneNumber">Mobile Number*</label>
                                <input
                                    type="text"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="queryMessage">Your Message</label>
                                <textarea
                                    id="queryMessage"
                                    name="queryMessage"
                                    value={formData.queryMessage}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <button type="submit" className="submit-button">Submit</button>
                            {status && (
                                <p className={`form-status form-status-${status.type}`} role="status">
                                    {status.message}
                                </p>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SubmitQuery;